function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScedasTimekeeperLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3832 1323",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SCEDAS",
    transform: "matrix(4.16667,0,0,4.16667,1546.8,753.778)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-346.549,-153.017)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.74,144.4C377.53,152.51 384.85,155.08 392.27,155.08C399.19,155.08 405.03,152.31 405.03,146.47C405.03,142.02 402.16,139.95 394.44,138.66L382,136.39C370.93,134.39 362.42,128.97 362.42,116.39C362.42,103.04 374.49,94.39 390.61,94.39C408.81,94.39 419.19,102.39 420.61,116.05L404.44,116.05C403.84,109.91 398.5,106.65 390.78,106.65C383.78,106.65 379.12,110.11 379.12,115.16C379.12,120.21 382.58,121.39 389.3,122.67L402.75,125.24C415.02,127.42 421.84,133.75 421.84,145.32C421.84,158.97 409.18,167.37 392.84,167.37C374.74,167.37 361.69,159.96 360.21,144.43L376.74,144.4Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.79,154.19C472.39,154.19 476.55,149.35 477.79,142.52L494.4,142.52C491.64,157.16 481.84,167.34 463.75,167.34C442.68,167.34 429.13,152.41 429.13,130.85C429.13,109.29 442.68,94.36 463.75,94.36C481.84,94.36 491.64,104.44 494.4,119.18L477.83,119.18C476.55,112.35 472.39,107.51 463.83,107.51C452.65,107.51 446.62,116.21 446.62,130.85C446.62,145.49 452.62,154.19 463.83,154.19",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.84,166.16L504.84,95.54L558.25,95.54L558.25,108.7L521.55,108.7L521.55,124.12L553.89,124.12L553.89,137.28L521.55,137.28L521.55,152.9L558.94,152.9L558.94,166.16L504.84,166.16Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.42,108.7L588.42,152.9L600.68,152.9C612.75,152.9 619.37,145.29 619.37,130.75C619.37,116.21 612.75,108.75 600.68,108.75L588.42,108.7ZM636.78,130.7C636.78,151.97 622.78,166.11 600.68,166.11L571.68,166.11L571.68,95.54L600.68,95.54C622.74,95.54 636.78,109.54 636.78,130.75",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.75,138L686.83,138L677,111.86L676.71,111.86L666.75,138ZM691.68,151L661.81,151L656,166.16L639.26,166.16L667.35,95.54L686.63,95.54L714.82,166.16L697.32,166.16L691.68,151Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.31,144.4C735.1,152.51 742.43,155.08 749.84,155.08C756.77,155.08 762.6,152.31 762.6,146.47C762.6,142.02 759.73,139.95 752.02,138.66L739.56,136.39C728.48,134.39 719.98,128.97 719.98,116.39C719.98,103.04 732.04,94.39 748.16,94.39C766.36,94.39 776.75,102.39 778.16,116.05L762,116.05C761.4,109.91 756.07,106.65 748.35,106.65C741.35,106.65 736.68,110.11 736.68,115.16C736.68,120.21 740.14,121.39 746.86,122.67L760.32,125.24C772.58,127.42 779.4,133.75 779.4,145.32C779.4,158.97 766.74,167.37 750.4,167.37C732.3,167.37 719.24,159.96 717.76,144.43L734.31,144.4Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.11,51.48L134.11,130.85L54.75,130.85L54.75,210.22L237.3,210.22L237.3,130.85L316.66,130.85L316.66,51.48L134.11,51.48Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.44,105.91C815.429,112.228 810.228,117.42 803.91,117.42C797.585,117.42 792.38,112.215 792.38,105.89C792.38,99.565 797.585,94.36 803.91,94.36C803.92,94.36 803.93,94.36 803.94,94.36C803.994,94.359 804.048,94.359 804.102,94.359C810.323,94.359 815.442,99.478 815.442,105.699C815.442,105.769 815.441,105.84 815.44,105.91ZM813.84,105.91C813.732,100.556 809.297,96.21 803.942,96.21C798.511,96.21 794.042,100.679 794.042,106.11C794.042,111.54 798.51,116.009 803.94,116.01C803.985,116.011 804.03,116.011 804.076,116.011C809.435,116.011 813.846,111.601 813.846,106.241C813.846,106.131 813.844,106.02 813.84,105.91ZM799.09,111.91L799.09,99.61L804.69,99.61C807.64,99.61 809.39,100.96 809.39,103.61C809.44,105.169 808.494,106.597 807.04,107.16L809.79,111.86L806.69,111.86L804.19,107.61L801.94,107.61L801.94,111.86L799.09,111.91ZM804.29,105.41C805.89,105.41 806.54,104.86 806.54,103.66C806.54,102.46 805.89,101.96 804.29,101.96L801.94,101.96L801.94,105.41L804.29,105.41Z",
    style: {
      fill: "rgb(70,20,110)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScedasTimekeeperLogo);
export default __webpack_public_path__ + "static/media/scedas-timekeeper-logo.799a10c1a3202404004c207ca5acbeff.svg";
export { ForwardRef as ReactComponent };